import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import Organs from "components/Organs";
import OrganForm from "components/OrganForm";
import { useMutation, useQuery } from "@apollo/client";
import { EDIT_ORGAN, ALL_ORGANS, DELETE_ORGAN } from "../queries";
import { TextField, Button, Select, MenuItem, Checkbox } from "@mui/material";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";

// Images
import bgImage from "assets/images/admin.png";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
const Usersadmin = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [organs, setOrgans] = useState([]);
  //console.log(setOrgans);
  const [organ, setOrgan] = useState(null);
  // eslint-disable-next-line
  const [organname, setName] = useState("");
  // eslint-disable-next-line
  const [organshort, setShort] = useState("");
  // eslint-disable-next-line
  const [organurl, setUrl] = useState("");
  // eslint-disable-next-line
  const [organmunicipality, setMunicipality] = useState("");
  //const [system, setSystem] = useState("");
  const [active, setActive] = useState(true);
  // eslint-disable-next-line
  const [domain, setDomain] = useState("");
  const [t] = useTranslation("common");
  //const [getOrgan, result] = useLazyQuery(FIND_ORGAN);
  ////console.log(getOrgan);
  //console.log(organname);
  //console.log(organshort);
  //console.log(organurl);
  //console.log(organmunicipality);
  //console.log(domain);
  ////console.log();
  ////console.log();
  ////console.log();
  const [editOrgan] = useMutation(EDIT_ORGAN, {
    refetchQueries: [{ query: ALL_ORGANS }],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const organss = useQuery(ALL_ORGANS, {
    pollInterval: 1000000,
  });

  useEffect(() => {
    let organsss = [];
    //let municipalitiess = [];
    if (organss.data) {
      organsss = organss.data.allOrgans;
      //setOrgans(organss);
      //console.log(organsss);
      setOrgans(organsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [organss]);
  const [deleteOrgan] = useMutation(DELETE_ORGAN, {
    refetchQueries: [{ query: ALL_ORGANS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  /*useEffect(() => {
    if (result.data) {
      setOrgan(result.data.findOrgan);
    }
  }, [result.data]);
  */
  const submit = async (event) => {
    event.preventDefault();
    //console.log(event.target.organshort.value);
    editOrgan({
      variables: {
        organname: event.target.organname.value,
        organshort: event.target.organshort.value,
        organmunicipality: event.target.organmunicipality.value,
        organurl: event.target.organurl.value,
        system: event.target.system.value,
        domain: event.target.domain.value,
      },
    });
  };
  const setDelete = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    deleteOrgan({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  if (organ) {
    return (
      <div>
        <h2>{organ.organmunicipality}</h2>
        <div>
          {organ.organsname}
          {organ.organshort}
        </div>
        <Button onClick={() => setOrgan(null)}>{t("common.close")}</Button>
      </div>
    );
  }
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="dark"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Toimielimet Admin{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="left"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h2>{t("headers.organs")}</h2>
              {organs.map((p) => (
                <form key={p.organsname} onSubmit={submit}>
                  {t("common.name")}
                  <TextField
                    name="organname"
                    value={p.organname}
                    onChange={({ target }) => setName(target.value)}
                  />
                  <br />
                  {t("common.abbreviation")}
                  <TextField
                    name="organshort"
                    value={p.organshort}
                    onChange={({ target }) => setShort(target.value)}
                  />
                  <br />
                  {t("common.municipal")}
                  <TextField
                    name="organmunicipality"
                    value={p.organmunicipality}
                    onChange={({ target }) => setMunicipality(target.value)}
                  />
                  <br />
                  Url
                  <TextField
                    name="organurl"
                    value={p.organurl}
                    onChange={({ target }) => setUrl(target.value)}
                  />
                  <br />
                  Domain
                  <TextField
                    name="domain"
                    value={p.domain}
                    onChange={({ target }) => setDomain(target.value)}
                  />
                  <br />
                  System
                  <Select name="system" id="system" label="System" value={p.system} select>
                    <MenuItem value="CaseM">CaseM</MenuItem>
                    <MenuItem value="Dynasty">Dynasty</MenuItem>
                    <MenuItem value="Tweb">Tweb</MenuItem>
                  </Select>
                  <br />
                  Active
                  <Checkbox name="active" checked={active} onChange={() => setActive(!active)} />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    type="submit"
                  >
                    {t("common.save")}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa toimielimen?")) {
                        setDelete(p.id);
                      }
                    }}
                  >
                    {t("common.delete")}
                  </Button>
                  <br />
                  <br />
                </form>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Organs />
      <OrganForm />
    </>
  );
};

export default Usersadmin;
